import axios from 'axios';

let token = document.head.querySelector('meta[name="csrf-token"]');

export default axios.create({
    // baseURL: 'https://api.example.com',
    headers: {
        common: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': token.content,
        },
        // Add other headers as needed for different request methods
    },
});
